module.exports = __webpack_public_path__ + "static/media/fast-sportTextEN.531ad1bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/fast-sport/fast-sportTextEN.svg
// module id = 2459
// module chunks = 7